/**
 * @generated SignedSource<<5b0012bb987e6fc118e268a5e23d5fc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumn_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_query" | "BoardInlineCreate_query" | "BoardTransitionZones">;
  readonly " $fragmentType": "BoardColumn_query";
};
export type BoardColumn_query$key = {
  readonly " $data"?: BoardColumn_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumn_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumn_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardInlineCreate_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardTransitionZones"
    }
  ],
  "type": "Query"
};

(node as any).hash = "858ee05ef97e4cc381a92b8f09e03004";

export default node;
